__turbopack_context__.v({
  "className": "instrument_serif_e321f285-module__TAKfYq__className",
});
